import arms from './arms'
import fury from './fury'
import protection from './protection'

const warrior = { specs: [arms, fury, protection] }

export default warrior
